module.exports = __webpack_public_path__ + "img/zoomex-view-small.c5c7037e.png";